import { commonSession } from "seneca-common/features/common/action-types";

const actionTypes = {
  COMPLETE_MODULE: commonSession.COMPLETE_MODULE,
  COMPLETE_SESSION: commonSession.COMPLETE_SESSION,
  COMPLETE_NOTES_ONLY_SESSION: commonSession.COMPLETE_NOTES_ONLY_SESSION,
  RECEIVE_USER_STUDY_STATS: "seneca/studyStats/RECEIVE_USER_STUDY_STATS",
  RECEIVE_RECONCILED_USER_STUDY_STATS:
    "seneca/studyStats/RECEIVE_RECONCILED_USER_STUDY_STATS",
  RECEIVE_COURSE_STUDY_STATS: "seneca/studyStats/RECEIVE_COURSE_STUDY_STATS",
  RECEIVE_RECONCILED_COURSE_STUDY_STATS:
    "seneca/studyStats/RECEIVE_RECONCILED_COURSE_STUDY_STATS",
  RECEIVE_SECTION_STUDY_STATS: "seneca/studyStats/RECEIVE_SECTION_STUDY_STATS",
  RECEIVE_RECONCILED_SECTION_STUDY_STATS:
    "seneca/studyStats/RECEIVE_RECONCILED_SECTION_STUDY_STATS",
  RECEIVE_CONTENT_STUDY_STATS: "seneca/studyStats/RECEIVE_CONTENT_STUDY_STATS",
  RECEIVE_AND_RESET_CONTENT_STUDY_STATS:
    "seneca/studyStats/RECEIVE_AND_RESET_CONTENT_STUDY_STATS",
  RECEIVE_RECONCILED_CONTENT_STUDY_STATS:
    "seneca/studyStats/RECEIVE_RECONCILED_CONTENT_STUDY_STATS",
  RECEIVE_ALL_USER_COURSES_STATS:
    "seneca/studyStats/RECEIVE_ALL_USER_COURSES_STATS"
};

export default actionTypes;
